const getPathModules = () => {
	const modules = document.location.pathname
		.replace(/^\/|\/$/g, '')
		.split('/');
	// exclude bookmark hashes
	return modules.filter((module) => !module.startsWith('bh_'));
};

export const PageProperties = {
	page_title: document.title,
	page_url: document.location.href,
	page_path: document.location.pathname,
	page_domain: document.location.hostname,
	get module_main() {
		return getPathModules()[0];
	},
	get module_sub() {
		const modules = getPathModules();
		return modules[1] ?? '';
	},
	get module_current() {
		const subModule = this.module_sub;
		return subModule.length > 1 ? subModule : this.module_main;
	},
};
/**
 * Small wrapper around Amplitude to make it easier to send events.
 *
 * - Only tries to send events if Amplitude is initialized
 */
export const track = (
	event: string,
	properties?: Record<
		string,
		| string
		| number
		| boolean
		| null
		| undefined
		| (string | number | undefined | null)[]
	>
) => {
	if (!window.amplitude) {
		return;
	}
	window.amplitude.track(event, { ...PageProperties, ...properties });
};

export const trackingReset = () => {
	if (!window.amplitude) {
		return;
	}
	window.amplitude.reset();
};

export enum AmplitudeCustomEvents {
	AppBannerClicked = 'App Banner Clicked',
	ErrorEncountered = 'Error Encountered',
	LoggedOut = 'Logged Out',
	ProjectCompleted = 'Project Completed',
	ProjectCreated = 'Project Created',
	ProjectLineChartInteraction = 'Project Line Chart Interaction',
	QuoteCompleted = 'Quote Completed',
	QuoteMatrixOpened = 'Quote Matrix Opened',
	QuoteMatrixQuantitiesChanged = 'Quote Matrix Quantities Changed',
	ProviderAdded = 'Provider Added',
	ProviderRemoved = 'Provider Removed',
	ReactionAdded = 'Reaction Added',
	RetrospectiveLinkingDragged = 'Retrospective Linking Dragged',
	RetrospectiveLinkingSaved = 'Retrospective Linking Saved',
	SearchPerformed = 'Search Performed',
	TaskCompleted = 'Task Completed',
	TimeOffCreated = 'Time Off Created',
	TimeTrackerPaused = 'Time Tracker Paused',
	TimeTrackerStarted = 'Time Tracker Started',
	TimesheetSubmitted = 'Timesheet Submitted',
	TimesheetUnsubmitted = 'Timesheet Unsubmitted',
	TimesheetLocked = 'Timesheet Locked',
	TimesheetUnlocked = 'Timesheet Unlocked',
	ELIChatQuestionAsked = 'ELI Chat Question Asked',
	ELIStopClicked = 'ELI Stop Clicked',
	ELICreditsRequested = 'ELI Credits Requested',
	ELICreditsAddClicked = 'ELI Credits Add Clicked',
	ELIProjectHealthOpened = 'ELI Project Health Opened',
	EliSuggestionButtonClicked = 'ELI Suggestion Button Clicked',
	RoleAddedToTask = 'Role Added To Task',
	RoleReplacedWithUser = 'Role Replaced With User',
}
